import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_async_btn = _resolveComponent("async-btn")!

  return (_openBlock(), _createBlock(_component_async_btn, {
    task: _ctx.task,
    icon: "fa fa-lock",
    label: `Login to ${_ctx.platform}`,
    rounded: "",
    onClick: _ctx.login,
    class: "full-width"
  }, null, 8, ["task", "label", "onClick"]))
}